import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
var _excluded = ["as", "itemAs", "children", "display"];
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import styled, { css } from 'styled-components';
import { getSpacing, getPropNamesFromPropDefinition, getPropFilter } from 'utils/ui';
import { positionProps, positionPropsDef, sizeProps, sizePropsDef, textProps, textPropsDef } from 'styles/styleProps';
var stylePropNames = getPropNamesFromPropDefinition([].concat(_toConsumableArray(positionPropsDef), _toConsumableArray(sizePropsDef), _toConsumableArray(textPropsDef)));
var shouldForwardProp = getPropFilter(['align', 'spacing', 'splitBy'].concat(_toConsumableArray(stylePropNames)));
var getSpacingFromTheme = function getSpacingFromTheme(p) {
  return getSpacing(p.spacing, p.theme);
};
var Item = styled.li.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'display';
  }
}).withConfig({
  displayName: "InlineList__Item",
  componentId: "sc-1cp0odj-0"
})(["display:", ";max-width:100%;"], function (p) {
  return p.display || 'inline-block';
});
var Wrapper = styled('ul').withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "InlineList__Wrapper",
  componentId: "sc-1cp0odj-1"
})(["", " list-style:none;margin:0;padding:0;min-width:0;", " ", " ", " & > ", "{vertical-align:", ";", " ", " ", "}"], positionProps, function (p) {
  return p.spacing && css(["margin-left:-", ";margin-bottom:-", ";"], getSpacingFromTheme, getSpacingFromTheme);
}, sizeProps, textProps, Item, function (p) {
  return p.align || 'top';
}, function (p) {
  return p.spacing && css(["padding-left:", ";padding-bottom:", ";"], getSpacingFromTheme, getSpacingFromTheme);
}, function (p) {
  return p.splitBy === 'comma' && css(["&:not(:last-of-type)::after{content:',';margin-right:0.3em;}"]);
}, function (p) {
  return p.splitBy === 'dot' && css(["&:not(:last-of-type)::after{content:'\xB7';display:inline-block;vertical-align:middle;margin:-0.15em 1ch 0;font-weight:bold;}"]);
});
var InlineList = function InlineList(_ref) {
  var _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'ul' : _ref$as,
    _ref$itemAs = _ref.itemAs,
    itemAs = _ref$itemAs === void 0 ? 'li' : _ref$itemAs,
    children = _ref.children,
    display = _ref.display,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    as: as
  }, otherProps), React.Children.map(children, function (child, i) {
    if (child) {
      return /*#__PURE__*/React.createElement(Item, {
        key: i,
        as: itemAs,
        display: display
      }, child);
    }
  }));
};
InlineList.Wrapper = Wrapper;
InlineList.Item = Item;
export default InlineList;